import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MobileAppService } from '../services/mobile-app.service';
import { LocaleService } from '../services/locale.service';

@Component({
  selector: 'app-gamepass-redirect',
  templateUrl: './gamepass-redirect.component.html',
  styleUrls: ['./gamepass-redirect.component.scss']
})
export class GamepassRedirectComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private mobileAppService: MobileAppService,
    private localeService: LocaleService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const type = params.type;
      const locale = params.locale;
      const forceRedirect = params.forceRedirect === '1' || params.forceRedirect === 'true' || params.forceRedirect === true;

      // On mobile we show an interim swiper page (unless forced to redirect)
      const isMobileViewport = window.matchMedia('(max-width: 991.98px)').matches;
      if (isMobileViewport && !forceRedirect) {
        this.router.navigate(['/gamepass-interim'], { queryParams: { type, locale } });
        return;
      }
      
      // Always use this uid
      const uid = '695bdcfed7faa5334ea4dc8e';

      // Validate type parameter
      if (!type || !['1', '2', '3'].includes(type)) {
        console.error('Invalid type parameter. Must be 1, 2, or 3');
        window.location.href = this.mobileAppService.getURL() + 'en/museums';
        return;
      }

      // Map type to tourId
      const tourIdMap = {
        '1': '695bf6db9933ee260e525657',
        '2': '695bf6899933ee260e525656',
        '3': '695be0129933ee260e525651'
      };
      const tourId = tourIdMap[type];

      // Generate random alphanumeric groupId
      const groupId = this.generateRandomGroupId();

      // Detect locale from URL or use provided locale
      let detectedLocale = locale || this.detectLocaleFromUrl() || 'en';

      // IMPORTANT: Always stay on the domain where the user opened this page.
      // This prevents redirecting to outdoor.flinkit.io (or any partner domain) from the showcase app domain.
      const baseURL = window.location.origin + '/';
      this.redirectToGamepass(baseURL, detectedLocale, uid, tourId, groupId);
    });
  }

  generateRandomGroupId(): string {
    // Generate a random long alphanumeric string (32 characters)
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 32; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  detectLocaleFromUrl(): string {
    const href = window.location.href;
    if (href.indexOf('/hu/') !== -1) {
      return 'hu';
    } else if (href.indexOf('/de/') !== -1) {
      return 'de';
    } else if (href.indexOf('/fr/') !== -1) {
      return 'fr';
    } else if (href.indexOf('/es/') !== -1) {
      return 'es';
    } else if (href.indexOf('/nl/') !== -1) {
      return 'nl';
    }
    return null;
  }

  redirectToGamepass(mobileURL: string, locale: string, uid: string, tourId: string, groupId: string): void {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    // On localhost, don't include locale prefix in path (Angular routes don't have locale prefixes in dev)
    // On production, include locale prefix as expected by the production build
    const pathPrefix = isLocalhost ? '' : locale + '/';
    
    const url = mobileURL + pathPrefix + 'museum-gamepass/?uid=' + uid + 
                '&locale=' + locale + 
                '&tid=' + tourId + 
                '&type=true' + 
                '&groupId=' + groupId + 
                '&limit=0' + 
                '&validity=0' + 
                '&showcase=true' + 
                '&virtual=true';
    
    window.location.href = url;
  }

}
